import React, { useState } from "react";

const Tour = ({
  mal_id,
  images: {
    jpg: { image_url },
  },
  synopsis,
  score,
  titles,
  title: name,
  removeAnime,
  url,
}) => {
  const [readMore, setReadMore] = useState(false);
  // console.log(url);
  let title;
  if (name == undefined && titles == undefined) title = "none";
  else if (name != undefined) title = name;
  else {
    title = titles[0].title || titles[1].title;
  }

  return (
    <>
      <article className="single-tour">
        <img src={image_url} alt={title} />
        <footer>
          <div className="tour-info">
            <h4>{title}</h4>
            <h4 className="rating">Score:{score}</h4>
            <p>
              {readMore
                ? synopsis
                : `${
                    synopsis ? synopsis.substring(0, 50) : "Nothing right now"
                  }...`}
              <button
                className="read-btn"
                onClick={() => setReadMore(!readMore)}
              >
                {readMore ? "show less" : "read more"}
              </button>
            </p>
            <a href={url} className="buy">
              🛒 Buy now
            </a>

            <button className="delete-btn" onClick={() => removeAnime(mal_id)}>
              Not interested
            </button>
          </div>
        </footer>
      </article>
    </>
  );
};

export default Tour;
